import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '@/locales/en/translation.json';
import authEN from '@/locales/en/auth.json';

/**
 * i18n Configuration
 *
 * Static configuration for English-only application.
 * Uses direct JSON imports (no http-backend) for optimal performance.
 */

const resources = {
  en: {
    translation: translationEN,
    auth: authEN,
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    debug: false, // Set to true for development debugging

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: false, // Disable suspense (no async loading needed)
    },
  });

export default i18n;
